module.exports = __webpack_public_path__ + "static/it-outsourcing-untold-truth@2x-ce3058ed63a25aff753fa7a114b0b51f.jpg";